import { render, staticRenderFns } from "./modal-sister-shops.vue?vue&type=template&id=03063cef"
import script from "./modal-sister-shops.vue?vue&type=script&lang=ts"
export * from "./modal-sister-shops.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03063cef')) {
      api.createRecord('03063cef', component.options)
    } else {
      api.reload('03063cef', component.options)
    }
    module.hot.accept("./modal-sister-shops.vue?vue&type=template&id=03063cef", function () {
      api.rerender('03063cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/modal-sister-shops.vue"
export default component.exports